"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var lodash_1 = __importDefault(require("lodash"));
var react_autocomplete_1 = __importDefault(require("react-autocomplete"));
var classnames_1 = __importDefault(require("classnames"));
var BlInput_1 = __importDefault(require("../FormComponents/BlInput"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var MIN_LENGHT = 3;
var CompanyAutocomplete = function (_a) {
    var onChange = _a.onChange, placeholder = _a.placeholder, source = _a.source, icon = _a.icon, _b = _a.value, value = _b === void 0 ? '' : _b, _c = _a.className, className = _c === void 0 ? '' : _c, _d = _a.rounded, rounded = _d === void 0 ? false : _d, _e = _a.required, required = _e === void 0 ? false : _e;
    var _f = react_1.useState(false), open = _f[0], setOpen = _f[1];
    var _g = react_1.useState(value), val = _g[0], setValue = _g[1];
    var _h = react_1.useState(source), items = _h[0], setItems = _h[1];
    var changeHandler = function (value) {
        setValue(value);
        onChange(value);
    };
    return (react_1.default.createElement(react_autocomplete_1.default, { open: open, wrapperProps: {
            className: styles_module_scss_1.default.wrapper,
        }, menuStyle: {
            borderRadius: '3px',
            boxShadow: '0 2px 12px rgba(0, 0, 0, 0.1)',
            background: 'rgba(255, 255, 255, 0.9)',
            padding: '2px 0',
            fontSize: '90%',
            position: 'fixed',
            overflow: 'auto',
            maxHeight: '50%',
            zIndex: 100,
        }, getItemValue: function (item) { return item.title; }, items: items, renderItem: function (item, isHighlighted) {
            var _a;
            return (react_1.default.createElement("div", { className: classnames_1.default(styles_module_scss_1.default.item, (_a = {},
                    _a[styles_module_scss_1.default.active] = isHighlighted,
                    _a)), key: item.title }, item.title));
        }, renderInput: function (props) {
            return (react_1.default.createElement(BlInput_1.default, __assign({ inputClassName: className, icon: icon, type: "text", rounded: rounded, placeholder: placeholder, required: required }, props)));
        }, value: val, onChange: function (e) {
            var v = e.target.value;
            changeHandler(v);
            var re = new RegExp(lodash_1.default.escapeRegExp(v), 'i');
            var isMatch = function (result) {
                return re.test(result.title);
            };
            var filtered = lodash_1.default.filter(source, isMatch);
            setItems(filtered);
            if (0 < v.length || v.length < MIN_LENGHT) {
                setOpen(false);
            }
            if (v.length >= MIN_LENGHT && filtered.length) {
                setOpen(true);
            }
        }, onSelect: function (val) {
            changeHandler(val);
            setOpen(false);
        } }));
};
exports.default = CompanyAutocomplete;
